import {
  OrganizationUserStatusType,
  OrganizationUserType,
  RevocationReasonType,
} from "@vowkey/common/admin-console/enums";
import { PermissionsApi } from "@vowkey/common/admin-console/models/api/permissions.api";
import { SelectionReadOnlyResponse } from "@vowkey/common/admin-console/models/response/selection-read-only.response";
import { BaseResponse } from "@vowkey/common/models/response/base.response";
// eslint-disable-next-line no-restricted-imports
import { KdfType } from "@vowkey/legacy-crypto";

export class OrganizationUserResponse extends BaseResponse {
  id: string;
  userId: string;
  type: OrganizationUserType;
  revocationReason: RevocationReasonType;
  status: OrganizationUserStatusType;
  permissions: PermissionsApi;
  externalId: string;
  accessSecretsManager: boolean;
  accessPam: boolean;
  resetPasswordEnrolled: boolean;
  hasMasterPassword: boolean;
  collections: SelectionReadOnlyResponse[] = [];
  groups: string[] = [];

  constructor(response: any) {
    super(response);
    this.id = this.getResponseProperty("Id");
    this.userId = this.getResponseProperty("UserId");
    this.type = this.getResponseProperty("Type");
    this.revocationReason = this.getResponseProperty("RevocationReason");
    this.status = this.getResponseProperty("Status");
    this.permissions = new PermissionsApi(this.getResponseProperty("Permissions"));
    this.externalId = this.getResponseProperty("ExternalId");
    this.accessSecretsManager = this.getResponseProperty("AccessSecretsManager") ?? false;
    this.accessPam = this.getResponseProperty("AccessPam") ?? false;
    this.resetPasswordEnrolled = this.getResponseProperty("ResetPasswordEnrolled") ?? false;
    this.hasMasterPassword = this.getResponseProperty("HasMasterPassword") ?? false;

    if (this.id == null) {
      throw new Error("Missing required property: Id");
    }

    const collections = this.getResponseProperty("Collections");
    if (collections != null) {
      this.collections = collections.map((c: any) => new SelectionReadOnlyResponse(c));
    }
    const groups = this.getResponseProperty("Groups");
    if (groups != null) {
      this.groups = groups;
    }
  }
}

export class OrganizationUserUserDetailsResponse extends OrganizationUserResponse {
  name: string | undefined;
  email: string;
  avatarColor: string;
  twoFactorEnabled: boolean;
  usesKeyConnector: boolean;
  claimedByOrganization: boolean;

  constructor(response: any) {
    super(response);
    this.name = this.getResponseProperty("Name");
    this.email = this.getResponseProperty("Email");
    this.avatarColor = this.getResponseProperty("AvatarColor");
    this.twoFactorEnabled = this.getResponseProperty("TwoFactorEnabled") ?? false;
    this.usesKeyConnector = this.getResponseProperty("UsesKeyConnector") ?? false;
    this.claimedByOrganization = this.getResponseProperty("ClaimedByOrganization") ?? false;

    if (this.email == null) {
      throw new Error("Missing required property: email");
    }
  }
}

export class OrganizationUserDetailsResponse extends OrganizationUserResponse {
  claimedByOrganization: boolean;
  ssoExternalId: string;

  constructor(response: any) {
    super(response);
    this.claimedByOrganization = this.getResponseProperty("ClaimedByOrganization") ?? false;
    this.ssoExternalId = this.getResponseProperty("SsoExternalId");
  }
}

export class OrganizationUserResetPasswordDetailsResponse extends BaseResponse {
  organizationUserId: string;
  kdf: KdfType;
  kdfIterations: number;
  kdfMemory: number | undefined;
  kdfParallelism: number | undefined;
  masterPasswordSalt: string | undefined;
  resetPasswordKey: string;
  encryptedPrivateKey: string;

  constructor(response: any) {
    super(response);
    this.organizationUserId = this.getResponseProperty("OrganizationUserId");
    this.kdf = this.getResponseProperty("Kdf");
    this.kdfIterations = this.getResponseProperty("KdfIterations");
    this.kdfMemory = this.getResponseProperty("KdfMemory");
    this.kdfParallelism = this.getResponseProperty("KdfParallelism");
    this.masterPasswordSalt = this.getResponseProperty("MasterPasswordSalt");
    this.resetPasswordKey = this.getResponseProperty("ResetPasswordKey");
    this.encryptedPrivateKey = this.getResponseProperty("EncryptedPrivateKey");
  }
}
